import Api from "../../services/apiListTrafigura";

/**
 * Store Trafigura: roles y permisos contra /api/trafigura (biomaxRoutes en el back).
 * Misma estructura que modSeguridad para que las vistas Trafigura lo usen igual.
 */
export default {
  namespaced: true,
  state: {
    roles: [],
    permisos: {},
    errorMsj: "",
  },
  getters: {},
  mutations: {
    setRoles: (state, roles) => {
      state.roles = roles;
    },
    setPermisos: (state, permisos) => {
      state.permisos = permisos;
    },
  },
  actions: {
    actGetRoles: async ({ commit }, params = {}) => {
      let response = await Api.getRoles(params);
      if (response.error) return response.error;
      commit("setRoles", response);
      return true;
    },

    actSaveRoles: async ({ commit }, data) => {
      let response = await Api.saveRoles(data);
      if (response.error) return response.error;
      return true;
    },

    actEditRoles: async ({ commit }, data) => {
      let response = await Api.editRoles(data);
      if (response.error) return response.error;
      return true;
    },

    actDeleteRoles: async ({ commit }, id) => {
      let response = await Api.deleteRoles(id);
      if (response.error) return response.error;
      return true;
    },

    actGetPermisos: async ({ commit }, payload) => {
      const id = payload && typeof payload === "object" ? payload.id : payload;
      const params =
        payload && typeof payload === "object"
          ? { cliente_plataforma_id: payload.cliente_plataforma_id }
          : {};
      let response = await Api.getPermisos(id, params);
      if (response.error) return response.error;
      commit("setPermisos", response);
      return true;
    },

    actSavePermisos: async ({ commit }, data) => {
      let response = await Api.savePermisos(data);
      if (response.error) return response.error;
      return true;
    },
  },
};
